import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteItem, fetchData, handleDragEnd, toggleStatus, } from "../../../utils/apiUtils";
import { ActionButton, PlusButton, ToggleSwitch } from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import DeleteModel from "../../../Components/DeleteModel";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import debounce from "lodash.debounce";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../helper/Breadcrumb";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";
import BackButton from "../../../Components/BackButton";

const Subcategory = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(true);
  const [subcategoryData, setsubcategoryData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [IsDeleting, setIsDeleting] = useState(false)
  const totalPages = Math.ceil(totalCount / perPage);
  const [search, setSearch] = useState("");
const [nextPosition, setNextPosition] = useState(0);
  const fetchsubcategoryData = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      parent_id: editData?.id,
      search: searchQuery,
    };
    await fetchData(
      "category-pagination",
      requestData,
      setsubcategoryData,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextPosition
    );
  };

  const debouncedFetcCategory = useCallback(
    debounce(fetchsubcategoryData, 1000),
    [perPage]
  );

  useEffect(() => {
    debouncedFetcCategory(1, search);
  }, [perPage, search]);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalCount) {
      fetchsubcategoryData(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("category", deleteItemId?.id, fetchsubcategoryData,[deleteItemId?.image]);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };


  const handleEditClick = (item) => {
    navigator("/add-category", {
      state: { id: item?.id },
    });
  };

  const handleAdd = () => {
    navigator("/add-category", {
      state: { parent_id: editData?.id, nextPosition},
    });
  };

  const handleOnDragEnd = (result) => {
    handleDragEnd({
      result,
      data: subcategoryData,
      setData: setsubcategoryData,
      apiEndpoint: "/category-position",
    });
  };

  const handleStatusToggle = async (item) => {
    const data = await toggleStatus("category-status", item?.id);
    if (Object.keys(data).length > 0) {
      setsubcategoryData((prevCategory) =>
        prevCategory.map((curr) =>
          curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const Tableheader = ["Sort Order", "Name", "Products", "Catalogue","Updated At", "Is Active", "Action"];

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Category", path: "/category" },
    { label: "Sub-Category", path: "/sub-category" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">{editData?.name} Sub Category</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div
          className="d-flex justify-content-between mb-3"
          style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
        >
         <PerPageSelect value={perPage} onChange={setPerPage}/>

          <div style={{ display: "flex", gap: "20px" }}>
            <BackButton to={"/category"}/>
              <TableSearch value={search} onChange={setSearch} />
            <PlusButton handleAdd={handleAdd} module={"Sub Category"} />
          </div>
        </div>

        <div className="row" style={{ marginTop: "-10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="sliders">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="table-responsive"
                      >
                        <table
                          className=" custom-table table table-striped"
                          cellSpacing="0"
                          id="subcategoryTable"
                        >
                          <thead>
                            <tr>
                              {Tableheader &&
                                Tableheader.length > 0 &&
                                Tableheader.map((item, index) => (
                                  <th className="font-weight-bold text-left" key={index}>
                                    {item}
                                  </th>
                                ))}
                            </tr>
                          </thead>

                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  <Spinner />
                                </td>
                              </tr>
                            ) : subcategoryData?.length > 0 ? (
                              subcategoryData?.map((item, id) => {
                                return (
                                  <Draggable
                                    key={item.id}
                                    draggableId={item.id.toString()}
                                    index={id}
                                  >
                                    {(provided) => (
                                      <tr
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                      >
                                        <td>{item.position}</td>
                                        <td> {item?.name}</td>

                                        <td>
                                          <button
                                            type="button"
                                            className="count-button1"
                                            onClick={() => {
                                              navigator(`/products/${item?.id}`, {
                                                state: item,
                                              });
                                            }}
                                          >
                                            {item._count?.products}
                                          </button>
                                        </td>

                                        <td className="text-left">
                                          <button
                                            type="button"
                                            className="count-button1"
                                            onClick={() =>
                                              navigator(`/catalogue/${item?.id}`, { state: item })
                                            }
                                          >
                                            {item._count?.CatalogueCategory}
                                          </button>
                                        </td>


                                            <td>{dateformate(item.updatedAt)}</td>
                                            {/* <td>{dateformate(item.createdAt)}</td> */}
                                        <td>
                                          <ToggleSwitch
                                            data={item}
                                            name="isActive"
                                            checked={item.isActive}
                                            module={"Sub Category"}
                                            handleStatusToggle={handleStatusToggle}
                                          />
                                        </td>
                                        <td>
                                          <ActionButton
                                            data={item}
                                            handleEditClick={handleEditClick}
                                            handleDelete={handleDelete}
                                            module={"Sub Category"}
                                          />
                                        </td>
                                      </tr>
                                    )}
                                  </Draggable>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  <h4>No data available</h4>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                {subcategoryData.length > 0 && (
                  <div style={{ marginTop: "30px" }}>
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <DeleteModel
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={confirmDelete}
          itemName="sub category"
          IsDeleting={IsDeleting}
        />
      )}
    </>
  );
};

export default Subcategory;
